/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import {
  TextField,
  Button,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Box,
  Typography,
  CircularProgress,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchClientsFournisseurs,
  addClientFournisseur,
  updateClientFournisseur,
  clearAlerts,
  clearSelectedClientFournisseur,
} from "../../store/clientFournisseurSlice";
import { TiersType } from "../../services/Enums";

const ClientFournisseurForm = () => {
  const dispatch = useDispatch();
  const { loading , selectedClientFournisseur} = useSelector((state) => state.clientFournisseur);

  useEffect(() => {
    return () => {
      dispatch(clearAlerts());
      dispatch(clearSelectedClientFournisseur());
    };
  }, []);

  useEffect(() => {
    if (selectedClientFournisseur) {
      setFormValues(prevValues => ({
        ...prevValues,
        ...selectedClientFournisseur,
        id: selectedClientFournisseur._id,
      }));
    }
  }, [selectedClientFournisseur]);
  

  const [formValues, setFormValues] = useState({
    id: -1,
    name: "",
    email: "",
    phone: "",
    address: "",
    type: "", // Key from TiersType
  });

  const [formErrors, setFormErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });

    // Dynamic error clearance
    if (name === "email" && formErrors.email) {
      if (/\S+@\S+\.\S+/.test(value)) {
        setFormErrors((prevErrors) => {
          const { email, ...rest } = prevErrors;
          return rest;
        });
      }
    } else if (name === "name" && formErrors.name) {
      if (value.trim()) {
        setFormErrors((prevErrors) => {
          const { name, ...rest } = prevErrors;
          return rest;
        });
      }
    } else if (name === "type" && formErrors.type) {
      if (value.trim()) {
        setFormErrors((prevErrors) => {
          const { type, ...rest } = prevErrors;
          return rest;
        });
      }
    }
  };

  const validateForm = () => {
    const errors = {};
    if (!formValues.name) errors.name = "Name is required";
    // if (!formValues.email) {
    //   errors.email = "Email is required";
    // } else if (!/\S+@\S+\.\S+/.test(formValues.email)) {
    //   errors.email = "Email is invalid";
    // }
    if (!formValues.type) errors.type = "Type is required";
    setFormErrors(errors);
    return errors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const errors = validateForm();
    if (Object.keys(errors).length === 0) {
      if (selectedClientFournisseur) {
        // Update existing client/fournisseur
        dispatch(updateClientFournisseur(formValues));
      } else {
        dispatch(addClientFournisseur(formValues));
      }
      dispatch(fetchClientsFournisseurs({ page: 1, limit: 5, type: formValues.type }));
      
    }
  };  

  return (
    <Box
      component="form"
      onSubmit={handleSubmit}
      sx={{ maxWidth: 500, mx: "auto", p: 3, boxShadow: 3, borderRadius: 2 }}
    >
  
      <TextField
        fullWidth
        label="Name"
        name="name"
        value={formValues.name}
        onChange={handleChange}
        error={!!formErrors.name}
        helperText={formErrors.name}
        margin="normal"
      />

      <TextField
        fullWidth
        label="Email"
        name="email"
        type="email"
        value={formValues.email}
        onChange={handleChange}
        error={!!formErrors.email}
        helperText={formErrors.email}
        margin="normal"
      />

      <TextField
        fullWidth
        label="Phone"
        name="phone"
        value={formValues.phone}
        onChange={handleChange}
        margin="normal"
      />

      <TextField
        fullWidth
        label="Address"
        name="address"
        value={formValues.address}
        onChange={handleChange}
        margin="normal"
      />

      <FormControl fullWidth margin="normal" error={!!formErrors.type}>
        <InputLabel id="type-label">Type</InputLabel>
        <Select
          labelId="type-label"
          name="type"
          value={formValues.type}
          onChange={handleChange}
        >
          <MenuItem value="" disabled>
            -- Select Type --
          </MenuItem>
          {Object.entries(TiersType).map(([key, value]) => (
            <MenuItem key={key} value={key}>
              {value}
            </MenuItem>
          ))}
        </Select>
        {formErrors.type && <Typography color="error">{formErrors.type}</Typography>}
      </FormControl>

      <Box mt={2}>
        <Button
          type="submit"
          variant="contained"
          color="primary"
          fullWidth
          disabled={loading}
          startIcon={loading && <CircularProgress size={20} />}
        >
          {selectedClientFournisseur? 'Update' : 'Add'}  
        </Button>
      </Box>
    </Box>
  );
};

export default ClientFournisseurForm;
